import { createRouter, createWebHistory } from 'vue-router'
import { useSessionStore } from '../stores/session'

export const router = createRouter({
  history: createWebHistory(),
  strict: false,
  routes: [
    { path: '/login', component: () => import('../views/LoginView.vue'), meta: { public: true } },
    { path: '/enroll', component: () => import('../views/EnrollView.vue'), meta: { public: true } },
    { path: '/', component: () => import('../views/DashboardView.vue') },
    { path: '/products', component: () => import('../views/ProductsView.vue') },
    { path: '/imports/:id?', component: () => import('../views/ImportProductsView.vue') },
    { path: '/products/new', component: () => import('../views/AddProductView.vue') },
    { path: '/products/:id', component: () => import('../views/ProductDetailView.vue') },
    { path: '/profile', component: () => import('../views/ProfileView.vue') },
    { path: '/admin', component: () => import('../views/AdminView.vue'), meta: { admin: true } },
  ],
})

router.beforeEach(async (to) => {
  const store = useSessionStore()
  if (!store.loaded) await store.refresh()
  if (!to.meta.public && !store.session.authenticated)
    return { path: '/login', query: { next: to.fullPath } }
  if (to.meta.admin && !store.isAdmin) return '/'
  if (to.path === '/login' && store.session.authenticated) return '/'
})
